import { FC, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { ProductTypeImage } from '../../@types/codegen/graphql';
import styles from './product-image-view.module.scss';
import classNames from 'classnames';
import { Icon } from '../elements/Icons/Icon';
import { fallbackImageUrl } from '../../helper/fallback-image';
import { RemoteImage } from '../../lib/remote-image';

interface IProductImageViewProps {
  currentImage: ProductTypeImage;
  isVisible: boolean;
  onClose: () => void;
}

export const ProductImageView: FC<IProductImageViewProps> = ({ currentImage, isVisible, onClose }) => {
  const [mounted, setMounted] = useState(false);
  const [isZoomedIn, setIsZoomedIn] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleClose = () => {
    onClose();
    setIsZoomedIn(false);
    setPosition({ x: 0, y: 0 });
  };

  return (
    <>
      {mounted &&
        createPortal(
          <div
            className={classNames({
              [styles.overlay]: true,
              [styles.isVisible]: isVisible,
            })}
            onMouseDown={handleClose}
          >
            <div className={styles.popup} onMouseDown={(e) => e.stopPropagation()}>
              <button className={styles.closeButton} onClick={handleClose}>
                <Icon size={'30px'} icon={'close'} color="" />
              </button>
              <RemoteImage
                sources={[
                  { maxWidth: '360px', src: fallbackImageUrl({ url: currentImage.url, w: '720', q: '60', crop: false }) },
                  { maxWidth: '768px', src: fallbackImageUrl({ url: currentImage.url, w: '1300', q: '60', crop: false }) },
                  { maxWidth: '1024px', src: fallbackImageUrl({ url: currentImage.url, w: '1000', q: '60', crop: false }) },
                  { maxWidth: '2000px', src: fallbackImageUrl({ url: currentImage.url, w: '2000', q: '60', crop: false }) },
                ]}
                src={fallbackImageUrl({ url: currentImage.url, w: '2000', q: '60', crop: false })}
                alt={currentImage?.alt ?? ''}
                title={currentImage.title}
                priority={false}
                width={currentImage.metadata.width}
                height={currentImage.metadata.height}
                className={classNames({
                  [styles.image]: true,
                  [styles.zoomedIn]: isZoomedIn,
                })}
                style={
                  isZoomedIn
                    ? {transform: `translate(${position.x}px, ${position.y}px) scale(2)`,}
                    : {}
                }
              />
            </div>
          </div>,
          document.body
        )}
    </>
  );
};
